import React, {useState, useEffect} from "react";

import './Devices.kits.scss';
import {Link} from "react-router-dom";
import moment from 'moment';
import {useLazyQuery} from "@apollo/client";
import gqlSchemaLibrary from "../services/graphql.schemas";
import ItemMenu from "../forms/menu/MenuComponent";
import SpinnerLoader from "../visuals/SpinnerLoader";
import DropdownText from "../forms/dropdown/dropdown.text";
import Modal from "react-modal";
import DevicesBaseAssign from "./Devices.assign";
import {useTranslation} from "react-i18next";
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};

Modal.setAppElement('#root');

const deviceStatus = {
    1: 'available',
    2: 'assigned',
    3: 'in-use',
    4: 'not-data',
    5: 'disabled'
};

function ItemBase({ type, item, patientList, loading, requestAssignKit }) {
    const {t} = useTranslation(['devices','common']);
    const [expand, setExpand] = useState(false);

    const renderStatus = (_item) => {
        if (_item.status === deviceStatus[1]) {
            return (<div className="__deviceStatus available"><span>{t('available-capitalize')}</span></div>)
        }
        if (_item.status === deviceStatus[2]) {
            return (<div className="__deviceStatus assigned"><span>{t('assigned-capitalize')}</span></div>)
        }
        if (_item.status === deviceStatus[3]) {
            return (<div className="__deviceStatus inUse"><span>{t('in-use')}</span></div>)
        }
        if (_item.status === deviceStatus[4] || _item.status === deviceStatus[5]) {
            return (<div className="__deviceStatus notTransmitting"><span>{t('common:no-data')}</span></div>)
        }
        return '';
    }

    const onClick = () => {
        if (item.kitId || type === 'patients') {
            AuditTrail.sendLog(PAGES.DEVICE_KIT_LIST, {tag: 'button', event: 'onToggle', action: 'row expand', expand: expand});
            setExpand(!expand);
        }
    }

    const patientAssigned = patientList.find(p => p._id === item.patientId);
    const patientBio = !!patientAssigned && !!patientAssigned.user ? `${patientAssigned.user.bio.lastname}, ${patientAssigned.user.bio.firstname}` : null;

    const _requestAssignKit = () => {
        requestAssignKit(patientAssigned, item);
    }

    const renderKit = () => {
        return (
            <div className="__item __kit">
                <div className={`__info_item ${expand && item.kitId ? '__expand' : ''}`}>
                    <div className="__info __bold" onClick={onClick}>
                        {
                            item.kitId ?
                                <i className="material-icons">
                                    { expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }
                                </i> : <i className="material-icons"></i>
                        }
                        <span>
                            {
                                item.kitId ? item.kitId : '--'
                            }
                        </span>
                    </div>
                    <p className="__bold">
                        {
                            item.kitId ? '--' : item.id
                        }
                    </p>
                     <p>
                        {
                            item.assignedAt ? moment(item.assignedAt).format('DD MMM YY H:mm') : '--'
                        }
                    </p>
                    <p>
                        {
                            item.kitId ? '--' : item.deviceSubtype
                        }
                    </p>
                    {renderStatus(item)}
                    <p>
                        {loading ? 'Loading' : (patientBio ? patientBio : '--')}
                    </p>
                    <p>
                        {
                            item.dateCreated ? moment(item.dateCreated).format('DD MMM YY H:mm') : '--'
                        }
                    </p>
                    {
                        item.status === deviceStatus[1]?
                            <ItemMenu label={'Item Options'} event={PAGES.DEVICE_KIT_LIST} eventParams={{item_id: item.kitId ? '--' : item.id}}>
                                <>
                                    <div className="_option" onClick={_requestAssignKit}>
                                        <p>
                                            {t('assign')} { item.kitId? t('kit') : t('device').toLowerCase() } {t('to-participant')}
                                        </p>
                                    </div>
                                </>
                            </ItemMenu> : <span></span>
                    }
                </div>
                {
                    expand && item.kitId ? item.devices.map((device, index) => (
                        <div className="__device" key={index}>
                            <p>
                            </p>
                            <p>
                                {device.deviceId}
                            </p>
                            <p></p>
                            <p>
                                {device.deviceSubtype}
                            </p>
                            {renderStatus(device)}
                            <p></p>
                            <p>
                                {
                                    device.assignedAt ? moment(device.assignedAt).format('DD MMM YY H:mm') : '--'
                                }
                            </p>
                        </div>
                    )) : ''
                }
            </div>
        )
    }

    const renderPatient = () => {
        return (
            <div className="__item __patient">
                <div className={`__info_item ${expand ? '__expand' : ''}`}>
                    <div className="__info __bold" onClick={onClick}>
                        <i className="material-icons">
                            { expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }
                        </i>
                        <span>
                            {loading ? 'Loading' : (patientBio ? patientBio : '--')}
                        </span>
                    </div>
                    <p className="__bold">
                        {item.kitId}
                    </p>
                    <p>
                        {item.name || '--'}
                    </p>
                    {renderStatus(item)}
                    <p>
                        {
                            item.assignedAt ? moment(item.assignedAt).format('DD MMM YY H:mm') : (item.dateCreated ? moment(item.dateCreated).format('DD MMM YY H:mm') : '--')
                        }
                    </p>
                    <p>
                    </p>
                </div>
                {
                    expand ? item.devices.map((device, index) => (
                        <div className="__device _2" key={index}>
                            <p>
                                {
                                    !device.kitId ? t('singleton'): ''
                                }
                            </p>
                            <p>
                                {device.deviceId}
                            </p>
                            <p>
                                {device.deviceSubtype}
                            </p>
                            {renderStatus(device)}
                            <p>
                                {
                                    device.assignedAt ? moment(device.assignedAt).format('DD MMM YY H:mm') : (device.dateCreated ? moment(device.dateCreated).format('DD MMM YY H:mm') : '--')
                                }
                            </p>
                        </div>
                    )) : ''
                }
            </div>
        )
    }

    if (type === 'kits') {
        return renderKit();
    } else if (type === 'patients') {
        return renderPatient();
    } else {
        return '';
    }

}

function DeviceItems({ type, typeFilter, peripherals, patientList, loading, loadData, requestAssignKit }) {
    const {t} = useTranslation(['devices','common']);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!!peripherals && !loadData) {
            setItems(peripherals);
        }
    }, [peripherals, loadData]);

    if (type === 'kits') {
        return (
            <div className="list kits">
                <div className="headers">
                    <p>{t('kit-id')}</p>
                    <p>{t('device-id')}</p>
                    <p>{t('date-assigned')}</p>
                    <p>{t('name')}</p>
                    <p>{t('status')}</p>
                    <p>{t('participants-name')}</p>
                    <p>{t('active-since')}</p>
                    <div></div>
                </div>
                {
                    items.map((item, index) => (<ItemBase type={type} key={index} item={item} patientList={patientList} loading={loading} requestAssignKit={requestAssignKit} />))
                }
                { loadData? <SpinnerLoader/>: '' }
            </div>)
    } else if (type === 'patients') {
        return (
            <div className="list patients">
                <div className="headers">
                    <p>{t('participants-name')}</p>
                    <p>ID</p>
                    <p>{t('name')}</p>
                    <p>{t('status')}</p>
                    <p>{t('active-since')}</p>
                    <p></p>
                    <div></div>
                </div>
                {
                    items.map((item, index) => (<ItemBase type={type} key={index} item={item} patientList={patientList} loading={loading} requestAssignKit={requestAssignKit} />))
                }
                { loadData? <SpinnerLoader/>: '' }
            </div>)
    } else {
        return '';
    }
}

function DevicesKits({ match, currentOrg, currentUser, toaster }) {
    const {t} = useTranslation(['devices','common','menu']);
    const [loadData, setLoadData] = useState(true);
    const [type, setType] = useState('kits');
    const [devicesKits, setDevicesKits] = useState([]);
    const [devicesPatients, setDevicesPatients] = useState([]);
    const [deviceToAssign, setDeviceToAssign] = useState(null);
    const [modalAssigned, setModalAssigned] = useState(false);
    const [patientList, setPatientList] = useState({ patients: [] });
    const [patientsLoading, setPatientsLoading] = useState(true);

    const [searchFocused, changeSearchFocused] = useState(false);
    const [search, changeSearch] = useState('');
    const [typeFilter, setTypeFilter] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);

    const getDeviceStatus = (item) => {
        if (!item.patientId) {
            return deviceStatus[1];
        }
        if (!!item.patientId && !item.dateUpdated) {
            return deviceStatus[2];
        }
        if (!!item.patientId && !!item.dateUpdated) {
            if ((Date.now() - item.dateUpdated) < (1000 * 60 * 60 * 0.5)) {
                return deviceStatus[3];
            }
            if ((Date.now() - item.dateUpdated) < (1000 * 60 * 60 * 2)) {
                return deviceStatus[3];
            }
            if ((Date.now() - item.dateUpdated) < (1000 * 60 * 60 * 24) || (Date.now() - item.dateUpdated) >= (1000 * 60 * 60 * 24)) {
                return deviceStatus[4];
            }
        }
    }

    const [getDevices] = useLazyQuery(gqlSchemaLibrary.devices.peripherial.getPeripherialsByOrg, {
        onCompleted: (onDevices) => {
            if (onDevices.getPeripherialsByOrg) {
                let _devicesKits = {};
                let _devicesKitsItems = [];
                let _devicesPatients = {};
                let _devicesPatientsItems = [];
                onDevices.getPeripherialsByOrg.map((device) => {
                    let keyDevice;
                    if (device.kitId) {
                        keyDevice = device.kitId;
                    } else {
                        keyDevice = device.deviceId;
                    }
                    if (keyDevice) {
                        if (!_devicesKits.hasOwnProperty(keyDevice)) {
                            _devicesKits[keyDevice] = {
                                _id: device._id,
                                id: device.deviceId,
                                kitId: device.kitId,
                                name: device.name ? device.name : '',
                                patientId: device.patientId,
                                dateCreated: device.dateCreated,
                                dateUpdated: device.dateUpdated,
                                assignedAt: device.assignedAt,
                                status: getDeviceStatus(device),
                                deviceSubtype: device.deviceSubtype,
                                deviceModel: device.deviceModel,
                                devices: []
                            };
                            _devicesKitsItems.push(_devicesKits[keyDevice]);
                        }
                        _devicesKits[keyDevice].devices.push(Object.assign({status: getDeviceStatus(device)}, device));
                    }

                    let keyPatient;
                    if (device.patientId) {
                        keyPatient = device.kitId ? device.kitId + device.patientId : device.patientId;
                    }
                    if (keyPatient) {
                        if (!_devicesPatients.hasOwnProperty(keyPatient)) {
                            _devicesPatients[keyPatient] = {
                                id: device.deviceId,
                                kitId: device.kitId,
                                name: device.name ? device.name : '',
                                patientId: device.patientId,
                                dateCreated: device.dateCreated,
                                dateUpdated: device.dateUpdated,
                                assignedAt: device.assignedAt,
                                status: getDeviceStatus(device),
                                devices: []
                            };
                            _devicesPatientsItems.push(_devicesPatients[keyPatient]);
                        } else {
                            if (device.assignedAt < _devicesPatients[keyPatient].assignedAt) {
                                _devicesPatients[keyPatient].assignedAt = device.assignedAt;
                            }
                        }
                        _devicesPatients[keyPatient].devices.push(Object.assign({status: getDeviceStatus(device)}, device));
                    }
                });
                setDevicesKits(_devicesKitsItems);
                setDevicesPatients(_devicesPatientsItems);
                setLoadData(false);
            }
        },
        fetchPolicy: 'cache-and-network'
    });

    const [fetchPatients] = useLazyQuery(gqlSchemaLibrary.patients.getPersonByOrganization, {
        onCompleted: ({ getPersonByOrganization }) => {
            console.log('[Patient List] User Patients: ', getPersonByOrganization);
            if (getPersonByOrganization) {
                setPatientList({ patients: getPersonByOrganization });
            }
            setPatientsLoading(false);
        },
        fetchPolicy: 'cache-and-network'
    });

    useEffect(() => {
        getDevices();
        fetchPatients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (type) => {
        return () => {
            AuditTrail.sendLog(PAGES.DEVICE_KIT_LIST, {tag: 'button', event: 'onClick', action: 'button tap', type: type});
            setType(type);
            setTypeFilter(null);
            setStatusFilter(null);
        }
    }

    const handleFocus = (bool) => {
        return () => {
            AuditTrail.sendLog(PAGES.DEVICE_KIT_LIST, {tag: 'input', event: 'onSearch', action: 'input search', type: type, focus: bool, value: search});
            changeSearchFocused(bool);
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value;
        changeSearch(value);
    }

    const onChangeType = (option) => {
        setTypeFilter(option.value);
    }

    const onChangeStatus = (option) => {
        setStatusFilter(option.value);
    }

    const assignKitToSelected = (patientAssigned, device) => {
        if (device) {
            setDeviceToAssign({
                _id: device._id,
                devices: device.devices,
                deviceSubtype: device.deviceSubtype,
                kitId: device.kitId? device.kitId : null,
                deviceId: device.kitId? device.kitId : device.id
            });
            setModalAssigned(true);
        }
    }

    const dropdownTypeOptions = [
        { label: t('all'), value: null },
        { label: t('program-kits'), value: 'program-kits' },
        { label: t('devices-not-kit'), value: 'devices' }
    ]

    const dropdownStatusOptions = [
        { label: t('all-status'), value: null },
        { label: t('available-capitalize'), value: deviceStatus[1], color: '#2299f9' },
        { label: t('assigned-capitalize'), value: deviceStatus[2], color: '#f2cd01' },
        { label: t('in-use'), value: deviceStatus[3], color: '#57c892' },
        { label: t('common:no-data'), value: deviceStatus[4], color: 'transparent', borderColor: '#ff6a96' }
    ]

    const filterBySearch = () => {
        let peripherals;
       // console.log('Status filter:',statusFilter)
        if (type === 'kits') {
            peripherals = devicesKits;
        } else {
            peripherals = devicesPatients;
        }
        const patientCandidates = patientList.patients.map(p => ({_id: p._id, name: `${p.user.bio.firstname || ''} ${p.user.bio.lastname || ''}`.toLowerCase()}))
        .filter(({_id, name}) => name.includes(search.toLowerCase()));
        if(!search){
         //   console.log('filter without serach',peripherals)
            return peripherals.filter(d => !statusFilter || d.status === statusFilter);
        } else {
           // console.log('filter and serach', peripherals)
            return peripherals.filter(d => {
                const statusMatch = !statusFilter || d.status === statusFilter;
                const kitIdMatch = (d.kitId || '').includes(search);
                const deviceIdMatch = (d.id || '').includes(search);
                const deviceSubtype = (d.deviceSubtype || '').includes(search);
                const patientIdMatch = patientCandidates.some(({_id}) => _id === d.patientId);
                return statusMatch && (kitIdMatch || deviceIdMatch || deviceSubtype || patientIdMatch);
            })
        }
    }

    const devicesAfterFilter = filterBySearch();
    const items = devicesAfterFilter.filter((d) => typeFilter? (typeFilter === 'devices'? !d.kitId : d.kitId) : true);

    const getCountDevices = () => {
        return items.reduce((p, c) => p += c.devices.length, 0);
    }

    const closeAssignedModal = () => {
        setDeviceToAssign(null);
        setModalAssigned(false);
        getDevices();
    }

    const onSuccessAssigned = (status) => {
        getDevices();
        closeAssignedModal();
    }

    const renderModal = () => {
        return (
            <Modal
                isOpen={modalAssigned}
                onRequestClose={closeAssignedModal}
                style={customStyles}
                contentLabel={t('assign-patch-device')}
            >
                {
                    deviceToAssign?
                        <DevicesBaseAssign currentOrg={currentOrg} deviceToAssign={deviceToAssign} onClose={closeAssignedModal} onSucces={onSuccessAssigned} isKit={deviceToAssign.kitId} /> : ''
                }
            </Modal>
        )
    }

    return (
        <div id="DevicesKits">
            <div className="filter">
                <div className="filterOptions">
                    <i className="material-icons">
                        <Link to="/devices">
                            arrow_back_ios
                        </Link>
                    </i>
                    <div className="deviceTitle">
                        <h3>{t('menu:kits-and-devices')}</h3>
                    </div>
                    <div className="btn-toggle" >
                        <span className={`${type === 'kits' ? 'active' : ''}`} onClick={onChange('kits')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" version="1.1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g transform="">
                                        <g transform="">
                                            <g transform="">
                                                <g transform="" stroke="#FFFFFF" strokeLinejoin="round" strokeWidth="0.88396">
                                                    <polyline id="Line-3" points="10.7840404 23.9642884 10.7840404 11.3731047 21.6583491 5.83298388"/>
                                                    <polyline id="Line-3" transform="translate(5.437154, 14.898636) scale(-1, 1) translate(-5.437154, -14.898636) " points="0 23.9642884 0 11.3731047 10.8743086 5.83298388"/>
                                                    <g id="Group" transform="translate(4.108206, 1.803805)">
                                                        <polyline id="Line-3" transform="translate(6.977732, 7.554710) scale(-1, 1) translate(-6.977732, -7.554710) " points="0 12.0875363 3.08115441 13.5984784 3.08115441 7.05106286 13.955463 1.51094204"/>
                                                        <polyline id="Line-3" transform="translate(8.518309, 6.799239) scale(-1, 1) translate(-8.518309, -6.799239) " points="6.16230882 13.5984784 3.08115441 12.0875363 3.08115441 5.54012082 13.955463 0"/>
                                                    </g>
                                                    <polygon id="Line" strokeLinecap="square" points="3.75712466e-17 5.58116021 10.7840404 -1.66697881e-13 21.6583491 5.58116021 21.6583491 18.3504668 10.8291745 23.959165 0 18.3504668"/>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </span>
                        <span className={`${type === 'patients' ? 'active' : ''}`} onClick={onChange('patients')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" version="1.1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g transform="">
                                        <g transform="">
                                            <g transform="">
                                                <g transform="" stroke="#FFFFFF" strokeLinejoin="round" strokeWidth="0.882">
                                                    <g id="assigned-kits">
                                                        <path d="M12,24 L24,24 C24,24 24,21.853539 22.9565217,19.766557 C22.178087,18.2107119 18.7826087,17.1578295 14.6086957,15.592593 L14.6086957,12.46212 C14.6086957,12.46212 16.173913,11.418629 16.173913,9.33164694 C16.6956522,9.33164694 17.2173913,7.24466493 16.173913,6.72291943 C16.173913,6.4130026 17.5711304,3.80010112 17.2173913,2.02720991 C16.6956522,-0.581517606 9.39130435,-0.581517606 8.86956522,1.5054644 C5.73913043,1.5054644 7.82608696,6.29926208 7.82608696,6.72291943 C6.7826087,7.24466493 7.30434783,9.33164694 7.82608696,9.33164694 C7.82608696,11.418629 9.39130435,12.46212 9.39130435,12.46212 L9.39130435,15.592593 C5.2173913,17.1578295 1.82086957,18.2107119 1.04347826,19.766557 C0,21.853539 0,24 0,24 L12,24 Z" id="participant"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
                <div className="searchFilters">
                    <div className="searchContainer">
                        <div className={`search ${searchFocused ? 'focused' : ''}`}>
                            <input value={search} placeholder={t('common:search')} onChange={handleSearch} onFocus={handleFocus(true)} onBlur={handleFocus(false)} />
                            <i className="material-icons">
                                search
                                </i>
                        </div>
                    </div>
                    <DropdownText
                        textFilter=""
                        transparent={true}
                        onChange={onChangeType}
                        options={dropdownTypeOptions}
                        label={t('filter-by').toUpperCase()}
                        value={typeFilter}
                        event={PAGES.DEVICE_KIT_LIST}
                    />
                    <DropdownText
                        textFilter=""
                        transparent={true}
                        onChange={onChangeStatus}
                        options={dropdownStatusOptions}
                        label={t('filter-by-status').toUpperCase()}
                        value={statusFilter}
                        icon={true}
                        event={PAGES.DEVICE_KIT_LIST}
                    />
                </div>
                <div className="_counter">
                    {getCountDevices()} {t('device')}{getCountDevices()>1? 's' : ''}
                </div>
            </div>
            <DeviceItems type={type} typeFilter={typeFilter} peripherals={items} patientList={patientList.patients} loading={patientsLoading} loadData={loadData} requestAssignKit={assignKitToSelected} />
            {renderModal()}
        </div>
    )
}

export default PageViewLog(DevicesKits);
